import React from 'react';
import { useDispatch } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import { Button, Divider } from 'components/ui';
import Markdown from 'components/Markdown/Markdown';
import localeUtils from 'utils/LanguageLocale';
import Actions from 'actions/Actions';
import Empty from 'constants/empty';
import GuestCheckoutJoinBIEN from 'components/RichProfile/MyAccount/OrderDetail/GuestCheckoutJoinBI/locales/GuestCheckoutJoinBI_en_US.js';
import GuestCheckoutJoinBIFR from 'components/RichProfile/MyAccount/OrderDetail/GuestCheckoutJoinBI/locales/GuestCheckoutJoinBI_fr_CA.js';

const getText = localeUtils.getLocalisedDataFromResource(GuestCheckoutJoinBIEN, GuestCheckoutJoinBIFR);

const GuestCheckoutJoinBI = props => {
    const {
        orderId, points = 0, guestProfile = Empty.Object, firstName = '', lastName = ''
    } = props;
    const dispatch = useDispatch();
    const email = guestProfile.email;
    const isEmailRegistered = guestProfile.isEmailRegistered || false;
    const isStoreBIMember = guestProfile.isStoreBIMember || false;

    const handleCreateAccount = () => {
        dispatch(
            Actions.showRegisterModal({
                isOpen: true,
                userEmail: email,
                isEmailDisabled: true,
                skipEmailLookup: true,
                biData: {
                    firstName,
                    lastName
                },
                isStoreUser: isStoreBIMember
            })
        );
    };

    const handleSignIn = () => {
        dispatch(
            Actions.showSignInModal({
                isOpen: true,
                email,
                isOrderConfirmation: true,
                extraParams: {
                    orderId,
                    ...(points > 0 && { potentialBiPoints: points })
                }
            })
        );
    };

    const handleClick = isEmailRegistered ? handleSignIn : handleCreateAccount;
    const buttonText = getText(isEmailRegistered ? 'signIn' : 'createAccount');
    const messageText = getText(isEmailRegistered ? 'dontMissOutSignIn' : 'dontMissOut', [points]);

    return (
        <div>
            <Divider
                marginBottom={5}
                display={['block', 'none']}
            />
            <Markdown
                marginBottom={3}
                content={messageText}
            />
            <Button
                variant='primary'
                width={['100%', null, '200px']}
                onClick={handleClick}
            >
                {buttonText}
            </Button>
            <Divider marginY={5} />
        </div>
    );
};

export default wrapFunctionalComponent(GuestCheckoutJoinBI, 'GuestCheckoutJoinBI');
